import _ from 'lodash';
import { useSelector } from 'react-redux';

/**
 * CDB-2017 — true when a Configure Role toggle hides an element for the current role.
 * Same rule as the existing child modules (`isAllowed` from PrivateRoute), applied only to
 * roles that hold the parent page, so a role reaching shared code without it keeps
 * everything. Mirrors CMS-backend `getModulesOff`.
 */
export const isToggledOff = (isAllowed, moduleKey, parentKey) => !isAllowed(moduleKey) && (!parentKey || isAllowed(parentKey));

/**
 * Strict module check for features granted by a module (e.g. the Session Data Report):
 * true only when the current role holds `moduleKey` (unlike `isAllowed`, no "allow
 * everything" fallback for admins or for roles without modules).
 */
export const useRoleHasModule = () => {
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);
  const excludedModules = useSelector((state) => state.manageRole?.excludedModules);
  const roleLoaded = !_.isEmpty(rolePermissionData);
  const excludedIds = (excludedModules || []).map((module) => module.id);
  const roleModuleKeys = (_.get(rolePermissionData, '[0].modules') || [])
    .filter((module) => module && !excludedIds.includes(module.id))
    .map((module) => module.key);
  return { roleLoaded, hasModule: (moduleKey) => roleLoaded && roleModuleKeys.includes(moduleKey) };
};
